import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import ProTip from './ProTip';
import { Button } from '@material-ui/core';
import GameSetup from './GameSetup';


export default function App() {
  return (
    <Container maxWidth="md">
      <Box xs="12" my={2} textAlign="center">
        <img
          src="./assets/landing/logo.png"
          alt="You Buzzed Yet? - The Great American Beer Drinking Game!"
          style={{ width: '100%', maxWidth: 700, height: 'auto' }}
        />
      </Box>
      <Box xs="12" my="2">
        <GameSetup />
      </Box>
      <Box my={4}>
        <Typography className="copyright" variant="body2" align="center">
          {'Copyright © YouBuzzedYet.com '}
          {' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
        <Typography variant="caption" align="center" display="block" style={{color: '#555'}}>
          {'v'}{process.env.REACT_APP_VERSION || '0.0.0'}
          {process.env.REACT_APP_BRANCH && process.env.REACT_APP_BRANCH !== 'main'
            ? ' (' + process.env.REACT_APP_BRANCH + ')'
            : ''}
        </Typography>
      </Box>
    </Container>
  );
}
